import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://www.startupbusinesspartners.com/api',
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // if (error.response && error.response.status === 401) {
    //   // Handle token expiration
    //   localStorage.removeItem('token');
    //   window.location.href = '/login';
    // }

    if (error.response && error.response.status === 401) {
  // Handle expired/invalid session
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('rememberedEmail');
  window.location.href = '/login';
}

    return Promise.reject(error);
  }
);

export default api;